import React, { useContext, useEffect } from 'react';

import Sidenavigation1 from '../../layouts/Sidenavigation1';
// import Sidenavigation from '../../layouts/Sidenavigation';
import { TheMasterContextProvider } from '../../MyContexts/Master_Context';
import { UserContext } from '../../MyContexts/Users_Context';
import Topnavigation from '../../layouts/Topnavigation';
import MasterSet from './MasterSect/MasterSet';


const MasterSettings = (props) => {
    const [user, setUser] = useContext(UserContext)

    useEffect(() => {

    }, [])


    return (
        <div className="ms-body ms-aside-left-open ms-primary-theme ms-has-quickbar">
            <TheMasterContextProvider>
               
                    {/* <Sidenavigation /> */}
                    <Sidenavigation1 user={user} />
                    <main className="body-content">
                        <Topnavigation />
                        <MasterSet />
                    </main>
                    {/* <Quickbar /> */}
               
            </TheMasterContextProvider>

        </div>
    );
}

export default MasterSettings;